import { Divider } from 'antd';
import React, { PureComponent } from 'react';
import { DeltaAtfcmSituationRegulationDto } from 'app/model/CORE';
import { Flex } from 'app/components/common/Flex';
import './DeltaMeasuresImpact.less';
import Utils from '../../../common/util/Utils';

interface DeltaMeasuresImpactProps {
    solutionMeasures: string[];
    deltaRegulations: DeltaAtfcmSituationRegulationDto[];
}

export class DeltaMeasuresImpact extends PureComponent<DeltaMeasuresImpactProps> {
    renderOtherMeasuresImpact = (delta: DeltaAtfcmSituationRegulationDto[]) => {
        const deltaDelay = delta
            .map(d => d.afterSituation.delayInMin - d.beforeDelayInMin)
            .reduce((acc, d) => acc + d, 0);

        // Remove measures of current solution
        delta = delta.filter(
            deltaRegulation => !this.props.solutionMeasures.includes(deltaRegulation.afterSituation.regulId),
        );
        const impactedTVs = delta.map(d => (
            <Flex key={d.afterSituation?.regulId}>
                {d.afterSituation.tvId}{' '}
                {delta.length > 1 ? `(${d.afterSituation.delayInMin - d.beforeDelayInMin}min)` : ''}
            </Flex>
        ));
        const otherMeasures = delta.map(delta => (
            <Flex key={delta.afterSituation.regulId}>{delta.afterSituation.regulId}</Flex>
        ));

        return (
            <Flex grow={false}>
                <Flex direction="vertical" grow={false}>
                    <Flex grow={false} className="label">
                        Delta Delay
                    </Flex>
                    <Flex className="value">
                        <Flex direction="vertical">
                            <Flex className="container">{deltaDelay}min</Flex>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex grow={false} className="divider-container">
                    <Divider type="vertical" className="divider" />
                </Flex>
                <Flex direction="vertical" grow={false}>
                    <Flex grow={false} className="label">
                        Measures
                    </Flex>
                    <Flex className="value">
                        <Flex direction="vertical">
                            <Flex direction="vertical" className="container">
                                {otherMeasures}
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex grow={false} className="divider-container">
                    <Divider type="vertical" className="divider" />
                </Flex>
                <Flex direction="vertical" grow={false}>
                    <Flex grow={false} className="label">
                        Impacted TVs
                    </Flex>
                    <Flex className="value">
                        <Flex direction="vertical">
                            <Flex direction="vertical" className="container">
                                {impactedTVs}
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        );
    };

    render() {
        // Remove insignificant impact (same delay && same flight count)
        const otherRegulationsDelta = this.props.deltaRegulations?.filter(
            deltaRegul =>
                deltaRegul.beforeDelayInMin !== deltaRegul.afterSituation.delayInMin ||
                deltaRegul.beforeImpactedFlightCount !== deltaRegul.afterSituation.impactedFlightCount,
        );

        let content;
        if (Utils.isEmpty(otherRegulationsDelta)) {
            content = <Flex>NO IMPACT</Flex>;
        } else {
            content = this.renderOtherMeasuresImpact(otherRegulationsDelta);
        }

        return (
            <Flex direction="vertical" className="delta-measures-impact">
                <Flex className="header" grow={false} size="2em">
                    IMPACT ON OTHER MEASURES
                </Flex>
                {content}
            </Flex>
        );
    }
}
